import { TemplateFormation } from '../types';

export const DefaultFormations: TemplateFormation[] = [
  {
    name: 'Ogre Chevron 3-4-4',
    type: 'Defensive',
    layout: [
      { row: 14, col: 7, positionType: 'Lineman' },
      { row: 14, col: 8, positionType: 'Big Guy' },
      { row: 14, col: 9, positionType: 'Lineman' },
      
      { row: 15, col: 6, positionType: 'Lineman' },
      { row: 15, col: 10, positionType: 'Lineman' },
      
      { row: 16, col: 4, positionType: 'Blitzer' },
      { row: 16, col: 12, positionType: 'Blitzer' },
      
      { row: 17, col: 7, positionType: 'Blocker' },
      { row: 17, col: 9, positionType: 'Blocker' },
      
      { row: 18, col: 8, positionType: 'Runner' },
      { row: 19, col: 8, positionType: 'Thrower' }
    ]
  },
  {
    name: 'Slayer Safety',
    type: 'Defensive',
    layout: [
      { row: 14, col: 7, positionType: 'Lineman' },
      { row: 14, col: 8, positionType: 'Lineman' },
      { row: 14, col: 9, positionType: 'Lineman' },
      
      { row: 16, col: 4, positionType: 'Blitzer' },
      { row: 16, col: 12, positionType: 'Blitzer' },
      
      { row: 16, col: 8, positionType: 'Blocker' },
      { row: 17, col: 6, positionType: 'Blocker' },
      { row: 17, col: 10, positionType: 'Blocker' },
      
      { row: 18, col: 4, positionType: 'Special' },
      { row: 18, col: 12, positionType: 'Special' },
      
      { row: 19, col: 8, positionType: 'Runner' }
    ]
  },
  {
    name: '5-5-1',
    type: 'Defensive',
    layout: [
      { row: 14, col: 6, positionType: 'Lineman' },
      { row: 14, col: 7, positionType: 'Lineman' },
      { row: 14, col: 8, positionType: 'Big Guy' },
      { row: 14, col: 9, positionType: 'Lineman' },
      { row: 14, col: 10, positionType: 'Lineman' },
      
      { row: 15, col: 3, positionType: 'Blitzer' },
      { row: 15, col: 6, positionType: 'Blocker' },
      { row: 15, col: 8, positionType: 'Blocker' },
      { row: 15, col: 10, positionType: 'Blocker' },
      { row: 15, col: 13, positionType: 'Blitzer' },
      
      { row: 18, col: 8, positionType: 'Runner' }
    ]
  },
  {
    name: '5-6',
    type: 'Defensive',
    layout: [
      { row: 14, col: 6, positionType: 'Lineman' },
      { row: 14, col: 7, positionType: 'Lineman' },
      { row: 14, col: 8, positionType: 'Big Guy' },
      { row: 14, col: 9, positionType: 'Lineman' },
      { row: 14, col: 10, positionType: 'Lineman' },
      
      { row: 16, col: 4, positionType: 'Blitzer' },
      { row: 16, col: 6, positionType: 'Blocker' },
      { row: 16, col: 8, positionType: 'Blocker' },
      { row: 16, col: 10, positionType: 'Blocker' },
      { row: 16, col: 12, positionType: 'Blitzer' },
      
      { row: 19, col: 8, positionType: 'Runner' }
    ]
  },
  {
    name: 'OTT (One Turn Touchdown)',
    type: 'Offensive',
    layout: [
      { row: 14, col: 7, positionType: 'Lineman' },
      { row: 14, col: 8, positionType: 'Big Guy' },
      { row: 14, col: 9, positionType: 'Lineman' },
      
      { row: 15, col: 7, positionType: 'Blocker' },
      { row: 15, col: 9, positionType: 'Blocker' },
      
      { row: 16, col: 6, positionType: 'Blitzer' },
      { row: 16, col: 10, positionType: 'Blitzer' },
      
      { row: 16, col: 8, positionType: 'Runner' },
      
      { row: 17, col: 4, positionType: 'Catcher' },
      { row: 17, col: 12, positionType: 'Catcher' },
      
      { row: 19, col: 8, positionType: 'Thrower' }
    ]
  }
];
